module.exports = __webpack_public_path__ + "static/img/tick-07.518cf4d8.svg";